import request from '@/utils/request'


// 查询七星彩列表
export function listQxc(query) {
    return request({
        url: '/admin/lottery/qxc/list',
        method: 'get',
        params: query
    })
}

// 查询最新一期七星彩数据
export function latestQxc() {
    return request({
        url: '/admin/lottery/qxc/latest',
        method: 'get',
    })
}

// 初始化七星彩数据
export function initAllQxc() {
    return request({
        url: '/admin/lottery/qxc/initAll',
        method: 'post'
    })
}

// 补全七星彩历史数据
export function fillHistoryData() {
    return request({
        url: '/admin/lottery/qxc/fillHistoryData',
        method: 'post'
    })
}

// 初始化七星彩统计数据
export function initAllQxcC() {
    return request({
        url: '/admin/lottery/qxc/initAllC',
        method: 'post'
    })
}

// 刷新七星彩缓存
export function refreshQxcCache() {
    return request({
        url: '/admin/lottery/qxc/refreshCache',
        method: 'delete',
    })
}
// 生成七星彩
export function generateQxc(data) {
    return request({
        url: '/admin/lottery/qxc/generate',
        method: 'post',
        data:data
    })
}

// 查询七星彩中奖数据
export function getQxcWinningData(query){
    return request({
        url: '/admin/lottery/qxc/getWinningData',
        method: 'get',
        params: query
    })
}
// 查询七星彩历史同期中奖数据
export function getNextQxcHistory(period){
    return request({
        url: '/admin/lottery/qxc/getNextHistory?period='+period,
        method: 'get'
    })
}

// 查询下期七星彩数字频率
export function getNextQxcNum(period){
    return request({
        url: '/admin/lottery/qxc/getNextNum?period='+period,
        method: 'get'
    })
}
